<div
  class="rounded-xl border-4 bg-white p-4 transition-colors"
  [class]="{
    'border-surface-300': appearance() === 'DEFAULT',
    'border-red-500': appearance() === 'INCORRECT',
    'border-emerald-500': appearance() === 'CORRECT',
  }"
>
  <rid-audio-button #audioButton [src]="src()" />
</div>
